import { connect } from 'react-redux';
import getThemeAction from '../../actions/theme/get';
import Component from './component';

const mapStateToProps = (state) => ({
  prefersDarkMode: state.theme.get('prefersDarkMode'),
});

const mapDispatchToProps = (dispatch) => ({
  handleGetThemeMode: async () => {
    await dispatch(await getThemeAction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
